import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { ProjectsResponseSchema } from "app/pages/activation/types/api";

export const ACTIVATION_OBJECTS_QUERY_KEY = "activation-objects";

const INITIAL_DATA: ProjectsResponseSchema = {
    activationSets: [],
    totalNumber: null,
    isAllAvailableReturned: false,
};

const useActivationSetListQuery = (
    customSelect?: (data: ProjectsResponseSchema) => ProjectsResponseSchema,
    enabled = true,
    forceGetAllAvailable = false,
) => {
    return useQuery({
        enabled,
        queryKey: [ACTIVATION_OBJECTS_QUERY_KEY],
        queryFn: async () => {
            const api = createActivationApi();

            return await api.activation.getActivations(forceGetAllAvailable);
        },
        // Don't throw to Error Boundary - React Query will handle error state
        // This prevents double logging (once in API service, once in Error Boundary)
        throwOnError: false,
        refetchOnMount: true,
        staleTime: Infinity,
        placeholderData: (previousData) => previousData || INITIAL_DATA,
        select: (data: ProjectsResponseSchema) => (customSelect && !data.manuallyUpdated ? customSelect(data) : data),
    });
};

export default useActivationSetListQuery;
